import { getCountryForTimezone } from 'countries-and-timezones';

import { readFromLocalStorage, writeToLocalStorage } from './localStorage';

const USER_COUNTRY_KEY = 'leora_user_country';

export function getUserCountry(): string | null {
  const cached = readFromLocalStorage(USER_COUNTRY_KEY);
  if (cached) return cached;

  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const country = getCountryForTimezone(tz)?.id ?? null;

    if (country) {
      writeToLocalStorage(USER_COUNTRY_KEY, country);
    }

    return country;
  } catch {
    return null;
  }
}
